'use strict';

/**
 * @author Maxim Seredkin
 */
export default ['$resource',
    function ($resource) {
        return $resource('api/projects/:projectId', null, {
            getAll: { method: 'GET', cancellable: true },
            get: { method: 'GET' },
            getEnableSigning: { url: 'api/projects/:projectId/enable-signing', method: 'GET' },
            create: { method: 'POST' },
            update: { method: 'PUT' },
            remove: { method: 'DELETE' },
            isUniqueName: { url: 'api/projects/unique/name/:name', method: 'GET' },
            outputs: { url: 'api/projects/:projectId/outputs', method: 'GET' },
            okveds: { url: 'api/projects/:projectId/okveds', method: 'GET' },
            contacts: { url: 'api/projects/:projectId/contacts', method: 'GET' },
            planFunds: { url: 'api/projects/:projectId/plan-funds', method: 'GET' },
            factFunds: { url: 'api/projects/:projectId/fact-funds', method: 'GET' },
            planFundsByYear: { url: 'api/projects/:projectId/plan-funds-by-year', method: 'GET' },
            factFundsByYear: { url: 'api/projects/:projectId/fact-funds-by-year', method: 'GET' },
            lands: { url: 'api/projects/:projectId/lands', method: 'GET' },
            readiness: { url: 'api/projects/:projectId/readiness', method: 'GET' },
            supports: { url: 'api/projects/:projectId/supports', method: 'GET' },
            status: { url: 'api/projects/:projectId/status', method: 'GET' },
            statuses: { url: 'api/projects/:projectId/statuses', method: 'GET' },
            progresses: { url: 'api/projects/:projectId/progresses', method: 'GET' },
            subProgresses: { url: 'api/projects/:projectId/sub-progresses', method: 'GET' },
            subProgressesByPhase: { url: 'api/projects/:projectId/phases/:phaseId/sub-progresses', method: 'GET' },
            maintenances: { url: 'api/projects/:projectId/maintenances', method: 'GET' },
            maintenanceKinds: { url: 'api/projects/:projectId/maintenance-kinds', method: 'GET' },
            taxes: { url: 'api/projects/:projectId/taxes', method: 'GET' },
            workPlaces: { url: 'api/projects/:projectId/work-places', method: 'GET' },
            chronologies: { url: 'api/projects/:projectId/chronologies', method: 'GET' },
            enableUpdate: { url: 'api/projects/:projectId/enable-update', method: 'GET' },
            approve: { url: 'api/projects/transactions/:transactionId/approve', method: 'PUT' },
            reject: { url: 'api/projects/transactions/:transactionId/reject', method: 'PUT' },
            rework: { url: 'api/projects/transactions/:transactionId/rework', method: 'PUT' },
            cancel: { url: 'api/projects/transactions/:transactionId/cancel', method: 'PUT' },
            considered: { url: 'api/projects/:projectCode/considered', method: 'GET' },
            transactions: { url: 'api/projects/transactions', method: 'GET' },
            deleteTransaction: { url: 'api/projects/transactions/:transactionId', method: 'DELETE' },
            existsTransactions: { url: 'api/projects/{code}/transactions/reviewed/exists', method: 'GET' },
            enableUpdateTransaction: { url: 'api/projects/transactions/:transactionId/enable-update', method: 'GET' },
            enableDeleteTransaction: { url: 'api/projects/transactions/:transactionId/enable-delete', method: 'GET' },
            enableDelete: { url: 'api/projects/:projectId/enable-delete', method: 'GET' },
            getStatistic: { url: 'api/projects/statistic', method: 'GET', cancellable: true },
            recovery: { url: 'api/projects/:projectId/recovery', method: 'post' },
            moveToTrash: { url: 'api/projects/:projectId/move-to-trash', method: 'post' },
            questions: { url: `${NEW_INVEST_BACKEND_URL}question-service/projects/questions/list`, method: 'GET' },
            changes: { url: 'api/projects/:projectId/changes', method: 'POST' },
            history: { url: 'api/projects/:projectId/history', method: 'GET' },
            emails: { url: '/api/message/emails', method: 'GET' },
            message: { url: '/api/message', method: 'POST' },
            backupUpload: { url: '/api/reports/backup', method: 'POST', headers: { 'Content-Type': 'multipart/form-data' }},
        });
    }];
